import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Aperture } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";

export default function HubList() {
  const { t } = useLang();
  const [hubs, setHubs] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/hubs", { params: { limit: 60 } })
      .then(({ data }) => setHubs(data))
      .catch((e) => setErr(formatApiError(e.response?.data?.detail) || e.message));
  }, []);

  if (err) return <div className="p-10 font-mono text-sm text-red-400">{err}</div>;
  if (!hubs)
    return (
      <div className="p-10 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
        {t("loading")}
      </div>
    );

  return (
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10 py-14" data-testid="hub-list-page">
      <header className="pb-12 border-b border-zinc-900">
        <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-zinc-500">
          {t("hubs_eyebrow")}
        </div>
        <h1 className="mt-3 font-serif text-5xl sm:text-6xl text-zinc-50 font-light tracking-tighter leading-[0.95]">
          {t("hubs_title")}
        </h1>
        <p className="mt-4 max-w-2xl text-zinc-400 font-light leading-relaxed">
          {t("hubs_lead")}
        </p>
      </header>

      {hubs.length === 0 ? (
        <div className="mt-12 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
          {t("hubs_empty")}
        </div>
      ) : (
        <ul className="mt-12 grid gap-px bg-zinc-900 border border-zinc-900 sm:grid-cols-2 lg:grid-cols-3">
          {hubs.map((h) => (
            <li key={h.slug} className="bg-[#36404A]">
              <Link
                to={`/c/${h.slug}`}
                className="group flex items-center justify-between px-6 py-7 hover:bg-zinc-900 transition-colors"
                data-testid={`hub-card-${h.slug}`}
              >
                <div className="flex items-center gap-4 min-w-0">
                  <div className="w-10 h-10 border border-zinc-800 flex items-center justify-center text-zinc-500 group-hover:text-sienna transition-colors">
                    <Aperture size={18} strokeWidth={1.5} />
                  </div>
                  <div className="min-w-0">
                    <div className="font-serif text-xl text-zinc-50 font-light leading-tight truncate">
                      {h.label}
                    </div>
                    <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 truncate">
                      /c/{h.slug}
                    </div>
                  </div>
                </div>
                <div className="ml-4 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400 shrink-0">
                  {h.count} {h.count === 1 ? t("frame") : t("frames")}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
